<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="4">
            <span style="font-size: 16px; font-weight: bold"> 書目管理 </span>
          </el-col>

          <el-col :span="8" :offset="12">
            <!-- <el-button
              id="test_lifeClass_btAdd"
              style="float: right; margin-right: 10px"
              type="primary"
              @click="openDialog"
              :disabled="true"
              >新增書目</el-button
            > -->

            <el-button
              style="float: right; margin-right: 10px"
              class="darkblue"
              @click="gotoImport('書目分格匯入')"
            >
              匯入分格
            </el-button>

            <el-button
              style="float: right; margin-right: 10px"
              class="darkblue"
              @click="gotoImport('書目匯入')"
            >
              匯入書目
            </el-button>
          </el-col>
        </el-row>
      </div>

      <el-col :span="6">
        <el-input
          :prefix-icon="qString == '' ? 'el-icon-search' : ''"
          placeholder="請輸入 書目編號、名稱、作者"
          v-model="qString"
          @keyup.enter.native="query"
        ></el-input>
      </el-col>

      <el-col :span="6" :offset="12">
         <el-button
            class="darkblue"
            @click="getBookListExcel"
             style="float: right; margin-right: 10px"
            >分格匯出</el-button
          >
         <el-button
            class="darkblue"
            style="float: right; margin-right: 10px"
            @click="getExcel"
            >書目匯出</el-button
          >
      </el-col>

      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column
          prop="id"
          label="書目編號"
          width="80"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="bookName"
          label="書目名稱"
          width="150"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="bookType"
          label="類別"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="author"
          label="作者"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="version"
          label="版本"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="bookList"
          label="分格數"
          width="80"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="count"
          label="總字數"
          width="80"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="suspend"
          label="狀態"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.suspend"
              active-color="#e57470"
              inactive-color="#7ebe50"
              active-text="停用"
              inactive-text="啟用"
              @change="suspendChange(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="250"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-row style="margin-bottom: 10px">
              <!-- <el-button class="darkblue" size="small" :disabled="true"
                >通過學員</el-button
              > -->
              <el-button
                type="primary"
                size="small"
                @click="gotoBookList(scope.row)"
                >編輯書目與分格</el-button
              >

              <el-button
                type="danger"
                size="small"
                @click="deleteOne(scope.row)"
                >刪除</el-button
              >
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="書目資料" :visible.sync="dialogShow" width="40%">
      <bookAdd
        :clickTime="dialogTime"
        :id="dialogId"
        @close="closeDialog"
      ></bookAdd>
    </el-dialog>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import { InformType } from "@/utils/InformType";
import bookAdd from "./component/bookAdd";
import XLSX from "xlsx";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "book",

  components: { bookAdd },
  data() {
    return {
      isLoading: false,
      tableData: [],
      dialogShow: false,
      dialogTime: null,
      dialogId: NaN,
      addForm: {
        lifeName: "",
      },
      qString: "",
    };
  },

  created() {
    this.query();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.book.query(this.qString).then((res) => {
        this.tableData = res.data;
        this.isLoading = false;
      });
    },
    openDialog(row) {
      console.log(row);
      this.dialogTime = new Date();
      this.dialogShow = true;
      this.dialogId = row ? row.id : NaN;
    },
    closeDialog() {
      this.dialogShow = false;
      this.query();
    },
    deleteOne(row) {
      const h = this.$createElement;
      this.$confirm("提示", {
        message: h(
          "div",
          {
            style: {
              fontSize: "16px",
              fontWeight: "bold",
            },
          },
          [
            h(
              "p",
              {
                style: {
                  fontSize: "30px",
                },
              },
              "注意！"
            ),
            h("br", ""),
            h("p", "分格將一併刪除，且無法還原！"),
            h("p", "是否確定刪除書目？"),
          ]
        ),
        confirmButtonClass: "cb",
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.isLoading = true;
        if (row.id) {
          API.book
            .deleteOne(row.id)
            .then(() => {
              Utils.Message.send("刪除書目成功!", InformType.SUCCESS);
              this.isLoading = false;
              this.query();
            })
            .catch(() => {
              Utils.Message.send("刪除書目失敗!", InformType.ERROR);
              this.isLoading = false;
            });
        }
      });
    },

    gotoImport(s) {
      this.$router.push({ name: s });
    },

    gotoBookList(row) {
      this.$router.push({ path: `/bookList?id=${row.id}` });
    },

    suspendChange(row) {
      API.book
        .suspendChange(row.id)
        .then((res) => {
          Utils.Message.send("狀態修改成功!", InformType.SUCCESS);
          row.suspend = res.data;
          console.log(this.tableData);
        })
        .catch(() => {
          Utils.Message.send("狀態修改失敗!", InformType.ERROR);
        });
    },

    getExcel() {
      let data = this.tableData.map((it)=>{
        return [it.id,it.bookName,it.bookType,it.author,it.version,it.bookList,it.count,it.suspend];});

      data.unshift(["書目編號", "書目名稱", "類別", "作者","版本","分格數","總字數","是否停用"]);

      const ws = XLSX.utils.aoa_to_sheet(data);
    
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "書目總表");

      /* generate file and send to client */
      XLSX.writeFile(wb, "書目總表.xlsx");
    },

    getBookListExcel() {
      API.bookList.query().then((res) => {
        let data = res.data.map((it)=>{
          return [it.book.bookName,it.id,it.bookRange,it.count,it.chapter,it.chapterIndex];});

        data.unshift(["書目名稱", "分格編號", "分格範圍","字數"," 品項","品項編號"]);

        const ws = XLSX.utils.aoa_to_sheet(data);
    
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "書目分格總表");

        /* generate file and send to client */
        XLSX.writeFile(wb, "書目總表.xlsx");

   
      }).catch(() => {
        Utils.Message.send("匯出失敗!", InformType.ERROR);
      });
    }
  }
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
.cb {
  background-color: #bc200b;
  color: #ffffff;
}
</style>